export default __webpack_public_path__ + "static/media/nomba.5be623e9.svg";